import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('announcement-modal-layout', {
  root: {
    states: ['mobile'],
  },
});
